import currency from "currency.js";

export default {
  methods: {
    formatCurrency(value, award, abbreviate) {
      if (!value && value !== 0) return null;

      if (award && Number(award.awardId) !== 1) {
        const unitSingular =
          (abbreviate && award.unitSingularAbbreviation) || award.unitSingular || "unit";
        const unitPlural =
          (abbreviate && award.unitPluralAbbreviation) || award.unitPlural || "units";

        const formattedValue = currency(value).format({ symbol: "" }).replace(".00", "");
        const unit = Number(value) === 1 ? unitSingular : unitPlural;

        return `${formattedValue} ${unit}`;
      }

      return currency(value, { symbol: "$" }).format();
    },
  },
};
